var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridBillingClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "183px",
    height: "250px",
    viewBox: "0 0 183 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7535\u7F51\u8BA1\u8D39\u56DE\u8DEF-\u95ED\u5408") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3076-\\u4E00\\u6B21\\u8FDB\\u7EBF\\u56FE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-221.000000, -201.000000)",
    id: "\\u7535\\u7F51\\u8BA1\\u8D39\\u56DE\\u8DEF-\\u95ED\\u5408"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(222.000000, 202.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-36",
    transform: "translate(90.000000, 179.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-30",
    transform: "translate(49.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-3",
    fill: "#52C41A",
    transform: "translate(12.000000, 6.500000) rotate(90.000000) translate(-12.000000, -6.500000) ",
    x: 7.5,
    y: -5.5,
    width: 9,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27\\u5907\\u4EFD-6",
    transform: "translate(33.000000, 6.500000) rotate(-90.000000) translate(-33.000000, -6.500000) translate(26.500000, -2.500000)",
    stroke: "#52C41A",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 0.5,
    x2: 6.5,
    y2: 10.5,
    id: "\\u76F4\\u7EBF-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 11.5,
    x2: 12.5,
    y2: 11.5,
    id: "\\u76F4\\u7EBF-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 14.5,
    x2: 10.5,
    y2: 14.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 17.5,
    x2: 8.5,
    y2: 17.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD-2"
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 49.5,
    y1: 6.5,
    x2: 0.5,
    y2: 6.5,
    id: "\\u76F4\\u7EBF-8\\u5907\\u4EFD",
    stroke: "#52C41A",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-38",
    transform: "translate(61.000000, 0.000000)",
    stroke: "#E64242",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 29.5,
    y1: 0.5,
    x2: 29.5,
    y2: 134.5,
    id: "\\u76F4\\u7EBF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.5,
    y1: 230,
    x2: 29.5,
    y2: 248,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "29.5 21 23 35 36 35"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-34",
    transform: "translate(0.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 29.5,
    cy: 8.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.5,
    y1: 4.5,
    x2: 37,
    y2: 12.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 4.5,
    x2: 40,
    y2: 12.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.5,
    y1: 8.5,
    x2: 43.5,
    y2: 8.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD",
    cx: 29.5,
    cy: 29.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.5,
    y1: 25.5,
    x2: 37,
    y2: 33.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 25.5,
    x2: 40,
    y2: 33.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.5,
    y1: 29.5,
    x2: 43.5,
    y2: 29.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-3",
    cx: 52.5,
    cy: 8.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.5,
    y1: 3.05311332e-16,
    x2: 52.5,
    y2: 17,
    id: "\\u76F4\\u7EBF-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.5,
    y1: 4.5,
    x2: 60,
    y2: 12.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.5,
    y1: 4.5,
    x2: 63,
    y2: 12.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.5,
    y1: 8.5,
    x2: 66.5,
    y2: 8.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-5",
    cx: 52.5,
    cy: 29.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.5,
    y1: 21,
    x2: 52.5,
    y2: 38,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-5",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.5,
    y1: 25.5,
    x2: 60,
    y2: 33.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.5,
    y1: 25.5,
    x2: 63,
    y2: 33.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.5,
    y1: 29.5,
    x2: 66.5,
    y2: 29.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-4",
    cx: 6.5,
    cy: 8.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 4.5,
    x2: 14,
    y2: 12.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 4.5,
    x2: 17,
    y2: 12.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 8.5,
    x2: 20.5,
    y2: 8.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 3.05311332e-16,
    x2: 6.5,
    y2: 17,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-6",
    cx: 6.5,
    cy: 29.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 25.5,
    x2: 14,
    y2: 33.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 25.5,
    x2: 17,
    y2: 33.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 29.5,
    x2: 20.5,
    y2: 29.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 21,
    x2: 6.5,
    y2: 38,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-6",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 29.5,
    y1: 163.5,
    x2: 29.5,
    y2: 207.5,
    id: "\\u76F4\\u7EBF-7",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14\\u5907\\u4EFD-19",
    transform: "translate(84.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    stroke: "#E64242",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 0.5,
    x2: 6.5,
    y2: 16.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 41.5,
    x2: 6.5,
    y2: 57.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84\\u5907\\u4EFD",
    points: "13 6 6.5 0 4.14945855e-15 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84\\u5907\\u4EFD-2",
    points: "13 14 6.5 8 4.14945855e-15 14"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FF4D4F",
    x: 2,
    y: 17,
    width: 9,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-13",
    transform: "translate(0.000000, 44.000000)",
    stroke: "#E64242",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84\\u5907\\u4EFD-3",
    transform: "translate(6.500000, 3.000000) scale(1, -1) translate(-6.500000, -3.000000) ",
    points: "13 6 6.5 0 4.14945855e-15 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84\\u5907\\u4EFD-4",
    transform: "translate(6.500000, 11.000000) scale(1, -1) translate(-6.500000, -11.000000) ",
    points: "13 14 6.5 8 4.14945855e-15 14"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14\\u5907\\u4EFD-11",
    transform: "translate(86.000000, 207.000000)",
    fill: "#FF4D4F"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-5",
    x: 0,
    y: 0,
    width: 9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-36",
    opacity: 0,
    transform: "translate(45.500000, 185.500000) scale(-1, 1) translate(-45.500000, -185.500000) translate(0.000000, 179.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-30",
    transform: "translate(49.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-3",
    fill: "#59D744",
    transform: "translate(12.000000, 6.500000) rotate(90.000000) translate(-12.000000, -6.500000) ",
    x: 7.5,
    y: -5.5,
    width: 9,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27\\u5907\\u4EFD-6",
    transform: "translate(33.000000, 6.500000) rotate(-90.000000) translate(-33.000000, -6.500000) translate(26.500000, -2.500000)",
    stroke: "#979797",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 0.5,
    x2: 6.5,
    y2: 10.5,
    id: "\\u76F4\\u7EBF-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 11.5,
    x2: 12.5,
    y2: 11.5,
    id: "\\u76F4\\u7EBF-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 14.5,
    x2: 10.5,
    y2: 14.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 17.5,
    x2: 8.5,
    y2: 17.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD-2"
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 49.5,
    y1: 6.5,
    x2: 0.5,
    y2: 6.5,
    id: "\\u76F4\\u7EBF-8\\u5907\\u4EFD",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinecap: "square"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridBillingClose);
export default __webpack_public_path__ + "static/media/gridBilling_close.bcc8c4c3c6a12675927016096387a333.svg";
export { ForwardRef as ReactComponent };